import React, { useEffect, useRef, useState } from 'react'
import { Table, Panel, Icon, Message } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import ProjectProgressStep from '../projectProgress/ProjectProgressStep'

export default function BudgetInstallmentPlanDetail({ schema }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Panel shaded bordered collapsible defaultExpanded>
        <Table
          // virtualized
          minHeight={150}
          autoHeight
          data={schema.value}
          // onRowClick={(data) => {
          //   console.log(data)
          // }}
        >
          <Column width={100} align="center" fixed>
            <HeaderCell>งวดที่</HeaderCell>
            {/* <Cell dataKey="installment" /> */}
            <Cell>
              {(rowData) => {
                if (!rowData.installment) {
                  return ''
                }

                if (rowData.isFocusInstallment) {
                  return (
                    <>
                      <Icon icon="hand-o-right" size="lg" style={{ color: '#2da888' }} />{' '}
                      {rowData.installment}
                    </>
                  )
                }

                return (
                  <>
                    <Icon icon="hand-o-right" size="lg" style={{ color: 'transparent' }} />{' '}
                    {rowData.installment}
                  </>
                )
              }}
            </Cell>
          </Column>

          <Column minWidth={350} flexGrow={1} align="center">
            <HeaderCell>ระยะเวลา</HeaderCell>
            {/* <Cell dataKey="timeline" /> */}
            <Cell>
              {(rowData) => {
                if (!rowData.installment) {
                  return <b>{rowData.timeline}</b>
                }

                return rowData.timeline
              }}
            </Cell>
          </Column>

          <Column width={200} align="right">
            <HeaderCell>งบประมาณ</HeaderCell>
            <Cell>
              {(rowData) => {
                if (!rowData.installment) {
                  return <b>{`รวม  ${rowData.budget && budgetFormat(rowData.budget || 0)}`}</b>
                }

                return rowData.budget ? budgetFormat(rowData.budget) : 0
              }}
            </Cell>
          </Column>

          <Column width={250} align="center">
            <HeaderCell>สถานะ</HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column width={200} align="center">
            <HeaderCell>วันที่เบิกจ่าย</HeaderCell>
            <Cell dataKey="disbursementDate" />
          </Column>
        </Table>

        <div style={{ marginTop: 20 }}>
          <ProjectProgressStep schema={schema.step} hidShaded={false} />
        </div>

        {schema?.message?.approvedComment?.length > 0 && (
          <>
            <br />
            <Message
              type={schema.message.type}
              description={schema.message.approvedComment.map((item, index) => {
                return (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: item }} />
                  </>
                )
              })}
            />
          </>
        )}
      </Panel>
    </>
  )
}
